import { Reveal, Eyebrow } from "../components/Reveal";
import { PriceList } from "../components/PriceList";
import { CTABand } from "../components/CTABand";
import { MarqueeStrip } from "../components/MarqueeStrip";

export default function Pricing() {
  return (
    <main data-testid="pricing-page">
      <section className="border-b border-border bg-secondary/40 pb-16 pt-40 sm:pb-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal y={20}>
            <Eyebrow>Price List</Eyebrow>
            <h1 className="mt-4 max-w-3xl font-display text-5xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
              Fair pricing, <em className="text-primary">always.</em>
            </h1>
            <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-muted-foreground">
              Every price, published openly — no surprises, no pressure. We believe outstanding,
              non-surgical aesthetics should be inclusive, not exclusive.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24">
        <Reveal>
          <PriceList />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-16 border border-border bg-secondary/40 p-8 text-center" data-testid="pricing-note">
            <p className="mx-auto max-w-2xl text-sm font-light leading-relaxed text-muted-foreground">
              Every treatment begins with a free 15-minute consultation, where your practitioner confirms
              the right plan and final pricing for you. Blood tests are carried out before any vitamin
              injection or TRT programme. Items marked "On consultation" are priced individually after
              assessment.
            </p>
          </div>
        </Reveal>
      </section>

      <MarqueeStrip />
      <CTABand />
    </main>
  );
}
